import React, { useEffect, useState } from 'react';
import {
    TugasContainer,
    SelectTugas,
    SearchTugas,
    TombolTambahTugas,
} from '../components/tambahTugas';

function FormTambahTugas(props) {
    const { setOpenmodal, getTicket } = props;
    const [status, setStatus] = useState('');
    const [search, setSearch] = useState('');
    console.log('cari ticket', status, search)
    const handleChange = () => {
        setOpenmodal(true);
    };

    const handleStatusChange = (e) => {
        const newStatus = e.target.value;
        setStatus(newStatus);
        console.log('Status dipilih:', newStatus);
    };

    const handleSearchChange = (e) => {
        const newSearch = e.target.value;
        setSearch(newSearch);
        console.log('Pencarian:', newSearch);
    };

    useEffect(() => {
        getTicket(status, search)
    }, [status, search])

    return (
        <TugasContainer>
            <SelectTugas name="status" value={status} onChange={handleStatusChange}>
                <option value="">Pilih Status</option>
                <option value="baru">Baru</option>
                <option value="diproses">Proses</option>
                <option value="selesai">Selesai</option>
            </SelectTugas>
            <SearchTugas
                placeholder="Cari tugas..."
                value={search}
                onChange={handleSearchChange}
            />
            <TombolTambahTugas onClick={handleChange}>Tambah</TombolTambahTugas>
        </TugasContainer>
    );
}

export default FormTambahTugas;
